import { FC } from 'react';
import { ITalentCars } from 'shared/interfaces/ICars';
import { CarsIcon } from '@room-match/shared-ui-components';
import InfoViewModal from 'components/MyInfo/InfoViewModal/InfoViewModal';

type CarViewModalProps = {
  data: ITalentCars;
  openDialog: boolean;
  handleDialog: VoidFunction;
};

const CarViewModal: FC<CarViewModalProps> = ({ data, openDialog, handleDialog }) => {
  const infoViewDetailsData = [
    {
      name: 'Manufacturer',
      details: data?.manufacturer?.name,
    },
    {
      name: 'Vehicle Type',
      details: data?.singleVariant?.type,
    },
    {
      name: 'Model',
      details: data?.model?.name,
    },
    {
      name: 'Year',
      details: data?.variant?.year || '',
    },
  ];
  const infoViewImageData = data?.attached_media;
  return (
    <InfoViewModal
      headerIcon={<CarsIcon fontSize="inherit" />}
      openDialog={openDialog}
      handleDialog={handleDialog}
      infoViewDetailsData={infoViewDetailsData}
      infoViewImageData={infoViewImageData}
      title="Car"
    />
  );
};

export default CarViewModal;
